import { Column } from 'react-table';
import { QuoteDownloadFileColumn } from 'shared/tables/columns/quote-file-download-column';
import { QuoteFormatDateColumn } from 'shared/tables/columns/quote-format-date-column';
import { TextColumn } from 'shared/tables/columns/text-column';
import { IAdditionalQuoteDocumentationItem } from 'shared/types';
import { QuoteFileDeleteColumn } from './quote-file-delete-column';

export const additionalQuoteDocumentationTableColumns: Column<IAdditionalQuoteDocumentationItem>[] = [
  {
    Header: 'Document Name',
    accessor: 'documentName',
    Cell: QuoteDownloadFileColumn,
    align: 'left',
  },
  {
    Header: 'User',
    accessor: 'user',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Upload Date',
    accessor: 'uploadDate',
    Cell: QuoteFormatDateColumn,
    align: 'left',
  },
  {
    Header: ' ',
    accessor: 'id',
    Cell: QuoteFileDeleteColumn,
    align: 'center',
  },
];
